import { render, staticRenderFns } from "./FirstAdminComp.vue?vue&type=template&id=025d2dc4&scoped=true&"
import script from "./FirstAdminComp.vue?vue&type=script&lang=js&"
export * from "./FirstAdminComp.vue?vue&type=script&lang=js&"
import style0 from "./FirstAdminComp.vue?vue&type=style&index=0&id=025d2dc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d2dc4",
  null
  
)

export default component.exports